import { TYPE_TIERS_DEBITEUR, TYPE_TIERS_DEBITEUR_FOURNISSEUR, TYPE_TIERS_FOURNISSEUR } from '@mairistem/comptabilite';

const TIERS_TYPES_OPTIONS = [
  {
    key: 'debiteur',
    text: 'Débiteur',
    value: TYPE_TIERS_DEBITEUR,
  },
  {
    key: 'fournisseur',
    text: 'Fournisseur',
    value: TYPE_TIERS_FOURNISSEUR,
  },
  {
    key: 'fournisseur et debiteur',
    text: 'Fournisseur et Débiteur',
    value: TYPE_TIERS_DEBITEUR_FOURNISSEUR,
  },
];

export default TIERS_TYPES_OPTIONS;
